export default defineNuxtPlugin((nuxtApp) => {
    const isLoading = useState('isLoading', () => false)

    nuxtApp.$router.beforeEach((to, from, next) => {
        isLoading.value = true
        next()
    })

    nuxtApp.$router.afterEach(() => {
        isLoading.value = false
    })
})
